export const groupByPriority = <T extends { priority: number }>(cleaningOrders: T[]) =>
  cleaningOrders.reduce(
    (cumulated, curr) =>
      curr.priority === 1
        ? { ...cumulated, highPriorityOrders: [...cumulated.highPriorityOrders, curr] }
        : { ...cumulated, normalOrders: [...cumulated.normalOrders, curr] },
    { normalOrders: [], highPriorityOrders: [] },
  )
